import {Component, Input} from '@angular/core';
import {AdvancedPieChartComponent} from '@swimlane/ngx-charts';

@Component({
  selector: 'app-brc-chart',
  templateUrl: './brc-chart.component.html'
})
export class BrcChartComponent extends AdvancedPieChartComponent {
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/dashboard/brc-chart.component.ts